import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';
import { useDragLayer } from 'react-dnd';

type CustomDragLayerProps = {
  renderContent: () => ReactNode;
  width: number;
};

export const CustomDragLayer: FC<CustomDragLayerProps> = ({ renderContent, width }) => {
  const { isDragging, currentOffset } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (!isDragging || !currentOffset || !width) {
    return null;
  }

  return (
    <Box
      sx={(theme) => ({
        width,
        position: 'fixed',
        pointerEvents: 'none',
        zIndex: theme.zIndex.tooltip,
        left: 0,
        top: 0,
        transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)`,
      })}
    >
      {renderContent()}
    </Box>
  );
};
